import { DocumentReference } from "firebase/firestore";

import { FirestoreOfflineDocument } from "@/core/modules/firestore/objects/FirestoreOfflineDocument";

import { StringArrayField, StringField } from "@/core/fields";

export class Norm extends FirestoreOfflineDocument {
  public name: string | undefined = undefined;
  public sections: string[] = [];

  public constructor(firestoreData?: Record<string, unknown>, id?: string) {
    super(id);
    if (firestoreData !== undefined) this.fromFirestore(firestoreData, id);
  }

  public fromFirestore(data: Record<string, unknown>, id?: string, firestoreRef?: DocumentReference): Norm {
    super.fromFirestore(data, id, firestoreRef);

    this.name = StringField.fromFirestore(data.name);
    this.sections = StringArrayField.fromFirestore(data.sections);

    return this;
  }

  public toFirestore(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = super.toFirestore();

    firestoreData.name = StringField.toFirestore(this.name);
    firestoreData.sections = StringArrayField.toFirestore(this.sections);

    return firestoreData;
  }

  public fromOfflineCache(data: Record<string, unknown>): Norm {
    super.fromOfflineCache(data);

    this.name = StringField.fromOfflineCache(data.name);
    this.sections = StringArrayField.fromOfflineCache(data.sections);

    return this;
  }

  public toOfflineCache(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = super.toOfflineCache();

    firestoreData.name = StringField.toOfflineCache(this.name);
    firestoreData.sections = StringArrayField.toOfflineCache(this.sections);

    return firestoreData;
  }
}
